import { Link } from '@/components/Link'
import { getOptions } from '@/data/config'
import type { LinkField } from '@/types/api'
import { linkTargetProps } from '@/utils/linkTarget'

type ContactLinkSize = 'md' | 'lg'

// lg is the price-sized treatment used in place of a price on detail views.
const sizeClasses: Record<ContactLinkSize, string> = {
	md: 'spaces:text-16/24 spaces:font-default spaces:text-content-2',
	lg: 'spaces:text-24/32 spaces:font-semi spaces:text-content-1'
}

interface ContactLinkProps {
	postText: string
	/** Render the contact word as a clickable link or plain text. @default true */
	asLink?: boolean
	/** Overrides the configured contact link (e.g. a portfolio property's own link). */
	link?: LinkField | null
	/** @default 'md' */
	size?: ContactLinkSize
}

export function ContactLink ({ postText, asLink = true, link, size = 'md' }: ContactLinkProps) {
	const contactLink = link ?? getOptions().contactLink

	const label = contactLink?.title || 'Contact'
	const href = contactLink?.url || '#'

	return (
		<div className={`spaces-contact-link spaces:flex spaces:flex-1 spaces:min-w-0 spaces:items-center ${sizeClasses[size]}`}>
			{asLink ? (
				<Link
					href={href}
					label={label}
					{...linkTargetProps(contactLink?.target)}
					defaultUnderline={size === 'lg'}
					weight={size === 'lg' ? 'semi' : 'default'}
					onClick={e => e.stopPropagation()}
				/>
			) : (
				<span className='spaces:text-brand-base'>{label}</span>
			)}
			<span className='spaces:ml-4'>{postText}</span>
		</div>
	)
}
